import { preferencesService } from '@/services/preferences.service'
import type { JobPreferencesCreate } from '@/types'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const jobPreferencesKeys = {
  all: ['job-preferences'] as const,
}

export function useJobPreferences() {
  return useQuery({
    queryKey: jobPreferencesKeys.all,
    queryFn: () => preferencesService.getJobPreferences(),
  })
}

export function useCreateJobPreferences() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: JobPreferencesCreate) => preferencesService.createJobPreferences(payload),
    onSuccess: (preferences) => {
      queryClient.setQueryData(jobPreferencesKeys.all, preferences)
    },
  })
}

export function useUpdateJobPreferences() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: Partial<JobPreferencesCreate>) =>
      preferencesService.updateJobPreferences(payload),
    onSuccess: (preferences) => {
      queryClient.setQueryData(jobPreferencesKeys.all, preferences)
    },
  })
}
